import { render, staticRenderFns } from "./PlayerLevelDecrementsTable.vue?vue&type=template&id=ca274f8c&scoped=true&"
import script from "./PlayerLevelDecrementsTable.vue?vue&type=script&lang=js&"
export * from "./PlayerLevelDecrementsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerLevelDecrementsTable.vue?vue&type=style&index=0&id=ca274f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca274f8c",
  null
  
)

export default component.exports